var _defs, _circle, _path, _circle2, _path2, _circle3, _path3, _path4, _rect, _rect2, _circle4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0dd944;}.cls-2{fill:#beffd3;}.cls-3{fill:#ce4272;}.cls-4{fill:#e9e6dd;}.cls-5{fill:#ef130e;}.cls-6{fill:#2f76ec;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 248.85,
    cy: 161.05,
    r: 134.64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319.87,100.19v28H262.66V158q19.65,4.23,30.84,16.67a42,42,0,0,1,11.2,29q0,19.53-15.05,32.78t-40,13.24q-25,0-42.41-17t-17.41-40.6A35.84,35.84,0,0,1,193.32,176a33.8,33.8,0,0,1,8.4-11.19q4.84-4.05,20.77-10,13.68-5.23,13.68-11.57V128.17H177.84v-28ZM256.19,170q-4.73,5.59-21.39,10.94-26.75,8.59-26.74,24.26,0,9.19,7.84,16A28.08,28.08,0,0,0,235.05,228a50.58,50.58,0,0,0,31.53-10.38q13.62-10.4,13.62-25.06Q280.2,173.57,256.19,170Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 294.09,
    cy: 394.54,
    r: 79.05,
    transform: "translate(-157.47 590.12) rotate(-76.72)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M279.47,354.13a7.4,7.4,0,0,1-7.32-7.63,7.49,7.49,0,0,1,7.47-7.48,7.75,7.75,0,0,1,7.63,7.63A7.65,7.65,0,0,1,279.47,354.13ZM272.15,447v-2.9c12.82-.46,14.8-2.29,14.8-14.2V388c0-12.06-1.83-13.28-14.8-14v-2.9h45.33V374c-12.83.61-15,2.44-15,14v41.91c0,11.45,2.45,13.74,15,14.2V447Zm37.69-92.89a7.4,7.4,0,0,1-7.32-7.63A7.49,7.49,0,0,1,310,339a7.75,7.75,0,0,1,7.63,7.63A7.66,7.66,0,0,1,309.84,354.13Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 412.13,
    cy: 313.31,
    r: 87.87,
    transform: "translate(36.85 669.93) rotate(-80.78)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377.12,371.76l-6.49-15.17c.3-.13,30.25-13.24,45.24-38.73,14.51-24.66,12.06-40.14,12-40.3l16.2-3.17c.43,2.14,3.72,21.71-14,51.84S378.55,371.15,377.12,371.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452.34,372c-1.2-.42-29.55-10.47-51.88-37-10.18-12.1-17.28-29.94-17.57-30.69l15.34-6.06c.07.16,6.43,16.12,14.86,26.13a115.81,115.81,0,0,0,44.68,32Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 363.4,
    y: 267.79,
    width: 101.86,
    height: 16.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 403.88,
    y: 255.89,
    width: 16.5,
    height: 20.14
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 125.3,
    cy: 334.61,
    r: 125.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.59,407,157.51,362.9H103.44l-12,43-29-2.26,19.91-55,30.31-97.28,40.5-2.94,29.18,96.83L201.17,402ZM132.85,277.83h-2.94l-19.46,61.09h40.27Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.208d7cca9317950e8980dedb1abc9ce0.svg";
export { ForwardRef as ReactComponent };